export class AcceptanceProtocolItem {
    id;
    acceptanceProtocolId;
    status;
    hardwareType;
    hardwareId;
    serialNumber;
    name;
    static fromApi(data) {
        if (Array.isArray(data)) {
            return data.map((et) => AcceptanceProtocolItem.define(et));
        }
        else if (data != null) {
            return AcceptanceProtocolItem.define(data);
        }
        else
            return null;
    }
    static define(data) {
        let acceptanceProtocolItem = new AcceptanceProtocolItem();
        acceptanceProtocolItem.id = data.Id;
        acceptanceProtocolItem.acceptanceProtocolId = data.AcceptanceProtocolId;
        acceptanceProtocolItem.status = data.Status;
        acceptanceProtocolItem.hardwareType = data.HardwareType;
        acceptanceProtocolItem.hardwareId = data.HardwareId;
        acceptanceProtocolItem.serialNumber = data.SerialNumber;
        acceptanceProtocolItem.name = data.Name;
        return acceptanceProtocolItem;
    }
}
export var HardwareType;
(function (HardwareType) {
    HardwareType["LOGGER"] = "Logger";
    HardwareType["DEVICE"] = "Device";
    HardwareType["EQUIPMENT"] = "Asset";
})(HardwareType || (HardwareType = {}));
